import { createApi, baseUrls } from './apiUtils';

const reviewApi = {
  admin: createApi({ baseURL: `${baseUrls.review}/admin/v1` }),
  app: createApi({ baseURL: `${baseUrls.review}/app/v1` }),
};

const REVIEW_URLS = {
  ADMIN_REVIEWS: 'reviews',
  ADMIN_REVIEW: (reviewId: string) => `reviews/${reviewId}`,

  APP_REVIEWS: 'reviews',
  APP_REVIEW: (reviewId: string) => `reviews/${reviewId}`,

  REVIEW_SUMMARY: (targetId: string) => `reviews/summary/${targetId}`, // ✅ fixed
};

export const createAdminReview = (data: any) =>
  reviewApi.admin.post(REVIEW_URLS.ADMIN_REVIEWS, data);

export const getAdminReview = (reviewId: string) =>
  reviewApi.admin.get(REVIEW_URLS.ADMIN_REVIEW(reviewId));

export const listAdminReviews = (params?: any) =>
  reviewApi.admin.get(REVIEW_URLS.ADMIN_REVIEWS, { params });

export const updateAdminReview = (reviewId: string, data: any) =>
  reviewApi.admin.patch(REVIEW_URLS.ADMIN_REVIEW(reviewId), data);

export const deleteAdminReview = (reviewId: string) =>
  reviewApi.admin.delete(REVIEW_URLS.ADMIN_REVIEW(reviewId));

export const createAppReview = (data: any) => reviewApi.app.post(REVIEW_URLS.APP_REVIEWS, data);

export const getAppReview = (reviewId: string) =>
  reviewApi.app.get(REVIEW_URLS.APP_REVIEW(reviewId));

export const listAppReviews = (params?: any) =>
  reviewApi.app.get(REVIEW_URLS.APP_REVIEWS, { params });

export const updateAppReview = (reviewId: string, data: any) =>
  reviewApi.app.patch(REVIEW_URLS.APP_REVIEW(reviewId), data);

export const deleteAppReview = (reviewId: string) =>
  reviewApi.app.delete(REVIEW_URLS.APP_REVIEW(reviewId));

export const getReviewSummary = (targetId: string) =>
  reviewApi.app.get(REVIEW_URLS.REVIEW_SUMMARY(targetId));
